import { z } from 'zod'

import { SystemFieldId } from 'common/fields/constants/EditableSystemFields'
import { ProErrorSchema } from 'shared/api/common/schemas/errors'
import { UserFieldSchema } from 'shared/api/common/schemas/userField'
import { UserFieldType } from 'shared/api/common/types'

import { usedEntitiesListSchema } from '../cms/schemas/usedEntitiesList'

export const UserFieldsSchemas = {
  moveToFolder: {
    response: z.object({
      field: UserFieldSchema,
    }),
    request: z.object({
      field_id: z.number(),
      folder_id: z.number(),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  moveToFolderBulk: {
    response: z.object({
      models: z.array(UserFieldSchema),
    }),
    request: z.object({
      ids: z.array(z.number()),
      folder_id: z.number(),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  getFolderContentCount: {
    response: z.object({
      fields_count: z.number(),
    }),
    query: z
      .object({
        path: z.string().optional(),
        active_only: z.string().optional(),
      })
      .optional(),
    path: z.undefined(),
  },
  listSchema: {
    response: z.object({
      fields: z.array(UserFieldSchema),
    }),
    request: z.undefined(),
    query: z.object({
      active_only: z.boolean().optional(),
      path: z.string().optional(),
      query: z.string().optional(),
    }),
    path: z.undefined(),
  },
  createSchema: {
    request: z.object({
      caption: z.string(),
      type: z.enum(UserFieldType),
      description: z.string().nullable(),
      path: z.string(),
    }),
    response: z.object({
      field: UserFieldSchema,
    }),
    query: z.undefined(),
    path: z.undefined(),
    errors: {
      ProError: ProErrorSchema,
    },
  },
  updateSchema: {
    request: z.object({
      field_id: z.number(),
      caption: z.string(),
      description: z.string().nullable(),
    }),
    response: z.object({
      field: UserFieldSchema,
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  archiveSchema: {
    response: z.object({
      field: UserFieldSchema,
    }),
    query: z.undefined(),
    request: z.object({
      field_id: z.number(),
    }),
    path: z.undefined(),
  },
  restoreSchema: {
    response: z.object({
      field: UserFieldSchema,
    }),
    query: z.undefined(),
    request: z.object({
      field_id: z.number(),
    }),
    path: z.undefined(),
  },
  deleteSchema: {
    request: z.object({
      field_id: z.number(),
    }),
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
  setSubscriberFieldSchema: {
    request: z.object({
      user_id: z.string(),
      field_id: z.number(),
      value: z.string().nullish(),
    }),
    response: z.undefined(),
    query: z.undefined(),
    path: z.undefined(),
  },
  setSystemFieldSchema: {
    request: z.object({
      user_id: z.string(),
      field: z.enum(SystemFieldId),
      value: z.string().nullish(),
    }),
    response: z.object({
      field: z.enum(SystemFieldId),
      value: z.string().optional(),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  getEntitiesListSchema: {
    // TODO: check if this is correct
    response: z.object({
      entities: usedEntitiesListSchema,
    }),
    query: z.object({
      field_id: z.number(),
    }),
    path: z.undefined(),
  },
  archiveBulkSchema: {
    request: z.object({
      ids: z.array(z.number()),
    }),
    response: z.object({
      models: z.array(UserFieldSchema),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  deleteBulkSchema: {
    request: z.object({
      ids: z.array(z.number()),
    }),
    response: z.object({
      models: z.array(UserFieldSchema),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
  restoreBulkSchema: {
    request: z.object({
      ids: z.array(z.number()),
    }),
    response: z.object({
      models: z.array(UserFieldSchema),
    }),
    query: z.undefined(),
    path: z.undefined(),
  },
}
